import { i18n } from "../../../boot/i18n";
// import { store } from "../../../store";

export default {
  routes: [
    {
      name: "sales-leads-search",
      path: "sales-leads/search/:query?",
      meta: { icon: "sales_lead", title: i18n.global.tc("Sales Lead", 100) },
      component: () => import("pages/employee/SalesLeads"),
    },
    {
      name: "sales-leads",
      path: "sales-leads/:filter?",
      meta: { icon: "sales_lead", title: i18n.global.tc("Sales Lead", 100) },
      component: () => import("pages/employee/SalesLeads"),
    },
  ],

  dialogs: [
    {
      name: "sales-lead-view",
      path: "/sales-leads/:salesLeadID/view",
      meta: {
        icon: "sales_lead",
        title: i18n.global.tc("Sales Lead"),
      },
      component: () => import("../../../dialogs/employee/SalesLeadView"),
    },
    {
      name: "sales-lead-new",
      path: "/sales-leads/new",
      meta: {
        icon: "edit",
        title: i18n.global.t("New Sales Lead"),
      },
      component: () => import("../../../dialogs/employee/SalesLeadEdit"),
    },
    {
      name: "sales-lead-edit",
      path: "/sales-leads/:salesLeadID/edit",
      meta: {
        icon: "edit",
        title: i18n.global.t("Edit Sales Lead"),
      },
      component: () => import("../../../dialogs/employee/SalesLeadEdit"),
    },
    {
      name: "project-sales-lead-new",
      path: "/projects/:projectID/sales-leads/new",
      meta: {
        icon: "edit",
        title: i18n.global.t("New Sales Lead"),
      },
      component: () => import("../../../dialogs/employee/SalesLeadEdit"),
    },
    {
      // Same dialog, reached from a service issue so the saved lead links back
      // to it (see SAVE_SALES_LEAD). Dialog routes are matched by
      // `route-matcher`, which has no optional-param syntax — hence a separate
      // route rather than `:serviceIssueID?` on the one above.
      name: "project-service-sales-lead-new",
      path: "/projects/:projectID/sales-leads/new/:serviceIssueID",
      meta: {
        icon: "edit",
        title: i18n.global.t("New Sales Lead"),
      },
      component: () => import("../../../dialogs/employee/SalesLeadEdit"),
    },
    {
      name: "project-sales-lead-edit",
      path: "/projects/:projectID/sales-leads/:salesLeadID/edit",
      meta: {
        icon: "edit",
        title: i18n.global.t("Edit Sales Lead"),
      },
      component: () => import("../../../dialogs/employee/SalesLeadEdit"),
    },
  ],
};
